import { createFileRoute } from '@tanstack/react-router'

import { z } from 'zod'

import {
  AuditExecutionSortField,
  AuditExecutionStatus,
  AuditStageTag,
  AuditTimeWindow,
  SortDirection,
} from '@/modules/graphql/codegen/graphql'
import { ExecutionLogs } from '@/pages/ExecutionLogs/ExecutionLogs'

export const executionLogsSearchSchema = z.object({
  statuses: z
    .array(z.nativeEnum(AuditExecutionStatus))
    .optional()
    .catch(undefined),
  tags: z.array(z.nativeEnum(AuditStageTag)).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  timeWindow: z.nativeEnum(AuditTimeWindow).optional().catch(undefined),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().positive().catch(20),
  sortField: z.nativeEnum(AuditExecutionSortField).optional().catch(undefined),
  sortDirection: z.nativeEnum(SortDirection).optional().catch(undefined),
  executionId: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_app/logs/execution')({
  component: ExecutionLogs,
  validateSearch: executionLogsSearchSchema,
})
